export default {
    common: {
        title: 'Bild bearbeiten',
        cancel: 'Abbrechen',
        save: 'sichern',
        crop: 'Ernte',
        adjustments: 'Anpassungen',
        filters: 'Filter',
        frames: 'Rahmen',
        overlays: 'Überlagerungen',
        text: 'Text',
        stickers: 'Aufkleber',
        brush: 'Bürste',
        ai: 'Bild mit KI erstellen',
        reset: 'Reset',
        comingSoon: 'Bald erhältlich...',
        apply: 'Bewerben',
        undo: 'Rückgängig machen',
        redo: 'Wiederholen',
        flipHorizontal: 'Horizontal umklappen',
        flipVertical: 'Umkehren',
        rotateClockwise: 'Drehen im Uhrzeigersinn',
        rotateAntiClockwise: 'Drehen Sie gegen den Uhrzeigersinn',
        warning: 'Warnung',
        discard: 'verwerfen',
        continue: 'Weitere Bearbeitung',
        discardHeading: 'Änderungen verwerfen?',
        discardSubHeading: 'Wenn du den Bildeditor schließt, werden deine Änderungen nicht gespeichert',
        subtitle: 'Die unterstützten Bildformate sind PNG und JPEG',
        clone: 'Klonen',
        delete: 'Löschen',
    },
};
